import { showErrorPopup } from '@attensi/error-popup'
import { type Ref, unref, watch } from 'vue'

export const useOnError = (error: Ref<any>) => {
  watch(
    () => error.value,
    () => {
      showErrorPopup({ error: unref(error) })
    }
  )
}
